import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import { requestPasswordChange } from "../api";
import { SendEmailPage } from "../components/sso/send_email_page";
import { getOrgOrGeneralUrl } from "../helpers";
import { OrgStore } from "src/store";

const RequestPasswordReset = () => {
  const { orgIdentifier } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const org = useSelector(OrgStore.selectors.find({ short_name: orgIdentifier }));

  const onSubmit = () => ({ realemail }) => {
    dispatch(requestPasswordChange({ email: realemail, org_id: org?.id }));
  };

  const goHome = () => () => history.push(getOrgOrGeneralUrl(orgIdentifier));

  return (
    <SendEmailPage
      onSubmitAfter={goHome}
      onSubmitBefore={onSubmit}
      submitTextAfter="Sign In"
      submitTextBefore="Send Link"
      textBefore="Not to worry. Please enter your email below and we’ll send you a link to reset your password."
      titleAfter="Email Sent."
      titleBefore="Reset Password"
    />
  );
};

export { RequestPasswordReset };
